import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import _extends from '/app/node_modules/babel-runtime/helpers/extends';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import { formatDateMixin } from '~/mixins';
import BtnFilters from './btn-filters';
import BtnWithoutCC from './btn-without-cc';

export default {
    mixins: [formatDateMixin],
    components: {
        BtnFilters: BtnFilters,
        BtnWithoutCC: BtnWithoutCC
    },
    data: function data() {
        return {
            noContent: true,
            // prueba: '',
            pendingMenuOpen: false,
            menu: this.$store.state.dashboard.filters.menuActivatorWorked
        };
    },

    computed: _extends({}, mapState({
        affiliationsWorked: function affiliationsWorked(state) {
            return state.dashboard.table.affiliationsWorked || [];
        }
    }), mapGetters({
        totalItems: 'dashboard/table/totalItemsWork',
        menuActivator: 'dashboard/filters/menuActivatorWorked'
    }), {
        fullTable: function fullTable() {
            return this.affiliationsWorked.length;
        }
    }),
    methods: {
        toDetailAffiliation: function toDetailAffiliation(data) {
            var info = {
                name: data.Seller,
                product: data.SelectProduct,
                idAffiliation: data.IdAffiliation,
                idAffiliationWorked: data.IdAffiliationWorked
            };
            this.$emit('leaving');
            this.$router.push({ path: '/affiliation-detail', query: { id: data.IdAffiliation, idA: data.IdAffiliationWorked, type: 'worked' } });
        },
        setsearch: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.$store.dispatch('dashboard/table/search', data);

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function setsearch(_x) {
                return _ref.apply(this, arguments);
            }

            return setsearch;
        }(),
        pagination: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(val) {
                var data;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                data = {
                                    type: 'Work',
                                    limit: val.pageSize,
                                    paginationNumber: val.pageNumber
                                };

                                this.$store.commit('dashboard/table/setPagination', val);
                                this.setsearch(data);

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function pagination(_x2) {
                return _ref2.apply(this, arguments);
            }

            return pagination;
        }(),
        search: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(term) {
                var data;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                data = {
                                    type: 'Work'
                                };

                                this.$store.commit('dashboard/table/setTerm', term);
                                this.setsearch(data);

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function search(_x3) {
                return _ref3.apply(this, arguments);
            }

            return search;
        }(),
        exportTable: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                this.$store.dispatch('dashboard/table/exportTable', {
                                    type: 'Work',
                                    idChannel: this.$store.state.dashboard.details.idChannel || -1,
                                    idTeam: this.$store.state.dashboard.details.idTeam || -1,
                                    idSeller: this.$store.state.dashboard.details.idSellerByTeam || -1
                                });

                            case 1:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function exportTable() {
                return _ref4.apply(this, arguments);
            }

            return exportTable;
        }(),
        setMenuActivator: function setMenuActivator() {
            this.$store.commit('dashboard/filters/setMenuActivatorTableWorked', true);
        },
        setCodigoComercio: function setCodigoComercio(soles, usd) {
            var string = '';
            if (soles != null && soles != undefined) {
                string = string + soles.toString() + ' ';
                if (usd != null && usd != undefined) string = string + '/ ';
            }
            if (usd != null || usd != undefined) string = string + usd.toString() + ' ';

            return string;
        }
    },
    watch: {
        menuActivator: function menuActivator(val) {
            this.menu = val;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/affiliations-worked.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/affiliations-worked.vue
// module chunks = 0 5